import { LOADING } from "../../../../constants/constant";
import {
    FORWARD_BRAND_FOR_ADMIN,
    FORWARD_BRAND_FOR_ADMIN_SUCCESS,
    FORWARD_BRAND_FOR_ADMIN_FAILED,
    FORWARD_BRAND_FOR_ADMIN_RESET
} from "../../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function forwardBrandReducer(state = initialState, action) {
  switch (action.type) {
    case FORWARD_BRAND_FOR_ADMIN: {
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;
    }

    case FORWARD_BRAND_FOR_ADMIN_SUCCESS: {
      let userRes = Object.assign({}, state);
      console.log(
        "fowward brand reducer => Success: " +
          JSON.stringify(action.data)
      );
      userRes.status = action.data.statusMessage;
      userRes.statusCode = action.data.status_code;
      userRes.statusMessage = action.data.status_message;
      userRes.isLoading = false;
      userRes.statusSting = action.data.data;

      return userRes;
    }
    case FORWARD_BRAND_FOR_ADMIN_FAILED: {
      console.error(
        "forward brands =>Error: " +
          JSON.stringify(action.error)
      );
      return Object.assign({}, state, action.error);
    }

    case FORWARD_BRAND_FOR_ADMIN_RESET: {
      return initialState;
    }

    default:
      return state;
  }
}
